import { render, staticRenderFns } from "./modalLeecherosPrecio.vue?vue&type=template&id=982949e2&scoped=true&"
import script from "./modalLeecherosPrecio.vue?vue&type=script&lang=js&"
export * from "./modalLeecherosPrecio.vue?vue&type=script&lang=js&"
import style0 from "./modalLeecherosPrecio.vue?vue&type=style&index=0&id=982949e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982949e2",
  null
  
)

export default component.exports